import { render, staticRenderFns } from "./TablePaginatedExpenses.vue?vue&type=template&id=6b3debe7&scoped=true"
import script from "./TablePaginatedExpenses.vue?vue&type=script&lang=js"
export * from "./TablePaginatedExpenses.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedExpenses.vue?vue&type=style&index=0&id=6b3debe7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3debe7",
  null
  
)

export default component.exports